<template>
  <div>
    <base-header
      type="gradient-success"
      class="pb-6 pb-0 pt-5 pt-md-3"
    ></base-header>
    <div class="container-fluid mt-3">
      <tabs :fill="false" class="flex-column flex-md-row">
        <div>
          <tab-pane>
            <span slot="title">
              <i class="ni ni-cloud-upload-96"></i>
              All products
            </span>
            <!-- all hacks table -->
            <div class="row">
              <div class="col">
                <div
                  class="card shadow"
                  :class="type === 'dark' ? 'bg-default' : ''"
                >
                  <div
                    class="card-header border-0"
                    style="background-color: #f9f9f9"
                  >
                    <div class="row align-items-center">
                      <div class="col-2">
                        <p class="mb-0">
                          Filter products
                        </p>
                      </div>
                      <div class="col-3">
                        <label class="form-control-label small text-muted mb-1">Category</label>
                        <select
                          aria-describedby="addon-right addon-left"
                          v-model="modals.item_category"
                          class="form-control form-control-alternative"
                          :class="{ 'is-invalid': categoriesError }"
                          autocomplete="off"
                          @change="getsubcategories($event)"
                          :disabled="loadingCategories"
                        >
                          <option value="" disabled="">
                            {{ loadingCategories ? 'Loading...' : 'Select category' }}
                          </option>
                          <option
                            v-for="category in categories"
                            :value="category._id"
                            :key="category._id"
                          >
                            {{ category.inventory_category_name }}
                          </option>
                        </select>
                        <small v-if="categoriesError" class="text-danger">{{ categoriesError }}</small>
                        <small v-if="categories.length === 0 && !loadingCategories" class="text-muted">No categories available</small>
                      </div>
                      <div class="col-3">
                        <label class="form-control-label small text-muted mb-1">Sub-Category</label>
                        <select
                          aria-describedby="addon-right addon-left"
                          v-model="modals.item_subcategory"
                          class="form-control form-control-alternative"
                          :class="{ 'is-invalid': subcategoriesError }"
                          autocomplete="off"
                          @change="filterproduct()"
                          :disabled="loadingSubcategories || !modals.item_category"
                        >
                          <option value="">
                            {{ loadingSubcategories ? 'Loading...' : modals.item_category ? 'Select sub-category' : 'Select category first' }}
                          </option>
                          <option
                            v-for="subcategory in subcategories"
                            :value="subcategory._id"
                            :key="subcategory._id"
                          >
                            {{ subcategory.inventory_subcategory_name }}
                          </option>
                        </select>
                        <small v-if="subcategoriesError" class="text-danger">{{ subcategoriesError }}</small>
                        <small v-if="subcategories.length === 0 && !loadingSubcategories && modals.item_category" class="text-muted">No subcategories available</small>
                      </div>
                      <div class="col-3">
                        <label class="form-control-label small text-muted mb-1">Brand</label>
                        <select
                          aria-describedby="addon-right addon-left"
                          class="form-control form-control-alternative"
                          :class="{ 'is-invalid': brandsError }"
                          autocomplete="off"
                          @change="filterbrandproduct()"
                          v-model="modals.item_brand"
                          :disabled="loadingBrands"
                        >
                          <option value="" disabled="">
                            {{ loadingBrands ? 'Loading...' : 'Select brand' }}
                          </option>
                          <option
                            v-for="brand in brands"
                            :value="brand.value_en"
                            :key="brand.value_en"
                          >
                            {{ brand.value_en + (brand.value_ar ? ' (' + brand.value_ar + ')' : '') }}
                          </option>
                        </select>
                        <small v-if="brandsError" class="text-danger">{{ brandsError }}</small>
                        <small v-if="brands.length === 0 && !loadingBrands" class="text-muted">No brands available</small>
                      </div>
                      <div class="col text-right">
                        <a
                          @click="cleardata()"
                          class="btn btn-sm btn-primary text-white"
                          >Clear</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="container mt-3" v-if="!deleteitem">
                    <div class="row pb-4">
                      <div
                        class="col-lg-4 mb-2"
                        v-for="(product, index) in productData"
                        :key="product._id || product.item_id || index"
                      >
                        <div>
                          <article class="card mb-2">
                            <div class="product-image">
                              <img
                                v-if="product.item_img == ''"
                                src="img/noimage.png"
                                alt="Image"
                                class="card-img-top"
                              />
                              <img
                                v-if="product.item_img != ''"
                                :src="product.item_img[0]"
                                alt="Image"
                                class="card-img-top"
                              />
                            </div>
                            <div class="card-body">
                              <h4 class="card-title">
                                {{ product.item_name }}
                              </h4>
                              <a
                                target="_self"
                                :href="'#/viewproduct/' + product.item_id"
                                class="btn btn-sm btn-primary"
                                ><i class="fa fa-bath"></i> View product</a
                              >
                              <base-button
                                type="danger"
                                size="sm"
                                @click="deleteproduct(product)"
                                icon="fa fa-trash"
                                >Delete</base-button
                              >
                              <base-button
                                type="success"
                                size="sm"
                                @click="openproduct(product)"
                                icon="fa fa-pencil"
                                >Edit</base-button
                              >
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-footer d-flex justify-content-end"
                    v-if="!deleteitem"
                  >
                    <nav aria-label="Page navigation example">
                      <ul class="pagination">
                        <li class="page-item">
                          <a class="page-link" @click="previouspage()">
                            <span aria-hidden="true"
                              ><i
                                aria-hidden="true"
                                class="fa fa-angle-left"
                              ></i
                            ></span>
                          </a>
                        </li>
                        <li class="page-item d-flex">
                          <p class="mb-0 px-1">
                            PAGE
                          </p>
                          <input
                            size="4"
                            class="mx-1 p-2 text-center"
                            style="border: 1px solid #e9ecff;border-radius: 5px !important;background-color: #e9ecff;width: 4em;"
                            type="number"
                            name="page_no"
                            id="page_no"
                          />
                          <base-button
                            block
                            type="primary"
                            class="px-3 mx-1"
                            title="GO"
                            size="sm"
                            @click="gotopage()"
                            >GO</base-button
                          >
                        </li>
                        <li class="page-item">
                          <a @click="nextpage()" class="page-link">
                            <span aria-hidden="true"
                              ><i
                                aria-hidden="true"
                                class="fa fa-angle-right"
                              ></i
                            ></span>
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="row" v-if="deleteitem">
                    <div class="col-lg-12">
                      <article class="card mb-2">
                        <center>
                          <div class="col-5">
                            <div>
                              <img
                                src="img/dashboard_no_item.jpg"
                                alt="Image"
                                class="card-img-top"
                              />
                            </div>
                            <a @click="cleardata()"
                              ><base-button
                                type="primary"
                                size="lg"
                                block
                                class="mb-5 mt-3"
                                icon="fa fa-image"
                                >Clear Search</base-button
                              ></a
                            >
                          </div>
                        </center>
                      </article>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab-pane>
          <!-- search product -->
          <tab-pane>
            <span slot="title">
              Search products
            </span>

            <!-- all product table -->
            <div class="row">
              <div class="col">
                <div
                  class="card shadow"
                  :class="type === 'dark' ? 'bg-default' : ''"
                >
                  <div
                    class="card-header border-0"
                    :class="type === 'dark' ? 'bg-transparent' : ''"
                  >
                    <div class="row align-items-center">
                      <div class="col-md-12 d-flex text-center">
                        <div class="col-md-2"></div>
                        <div class="col-md-6">
                          <base-input
                            alternative=""
                            class="mb-0"
                            label=""
                            placeholder="Search product"
                            input-classes="form-control-alternative"
                            v-model="search"
                          />
                        </div>
                        <div class="col-md-1">
                          <base-button
                            class="ml-2"
                            type="primary"
                            id="updatebtn"
                            v-on:click="searchproduct()"
                            >Search</base-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row pb-4">
                      <div
                        class="col-lg-4 mb-2"
                        v-for="(product, index) in searchData"
                        :key="product._id || product.item_id || index"
                      >
                        <div>
                          <article class="card mb-2">
                            <div class="product-image">
                              <img
                                v-if="product.item_img == ''"
                                src="img/noimage.png"
                                alt="Image"
                                class="card-img-top"
                              />
                              <img
                                v-if="product.item_img"
                                :src="product.item_img[0]"
                                alt="Image"
                                class="card-img-top"
                              />
                            </div>
                            <div class="card-body">
                              <h4 class="card-title">
                                {{ product.item_name }}
                              </h4>
                              <a
                                target="_self"
                                :href="'#/viewcomments/' + product.item_id"
                                class="btn btn-sm btn-primary"
                                ><i class="fa fa-bath"></i> View product</a
                              >
                              <base-button
                                type="danger"
                                size="sm"
                                @click="deleteproduct(product)"
                                icon="fa fa-trash"
                                >Delete</base-button
                              >
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab-pane>
          <tab-pane>
            <span slot="title">
              Add Product
            </span>

            <!-- all business table -->
            <div class="row">
              <div class="col">
                <div
                  class="card shadow"
                  :class="type === 'dark' ? 'bg-default' : ''"
                >
                  <div
                    class="card-header border-0"
                    :class="type === 'dark' ? 'bg-transparent' : ''"
                  >
                    <div class="row align-items-center">
                      <div class="col-md-12">
                        Basic Details
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="pb-4">
                      <form @submit.prevent>
                        <div class="">
                          <div class="row px-2">
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Item Name"
                                placeholder="Item Name"
                                input-classes="form-control-alternative"
                                v-model="model.item_name"
                              />
                              <div
                                v-if="$v.model.item_name.$error"
                                class="error h5 text-danger mt--4 pl-1"
                              >
                                Field is required.
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Item Name Arabic"
                                placeholder="Item Name Arabic"
                                type="text"
                                input-classes="form-control-alternative"
                                v-model="model.item_name_ar"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Item Description (English)"
                                placeholder="Item Description (English)"
                                input-classes="form-control-alternative"
                                v-model="model.item_description"
                              />
                            </div>
                            <div class="col-lg-12">
                              <base-input
                                alternative=""
                                label="Item Description (Arabic)"
                                placeholder="Item Description (Arabic)"
                                input-classes="form-control-alternative"
                                v-model="model.item_description_ar"
                              />
                            </div>
                            <div class="col-md-12">
                              <hr class="dashed" />
                            </div>
                            <div class="col-md-12">
                              <div class="d-flex justify-content-between align-items-center">
                                <span>Upload Image</span>
                                <small class="text-muted">
                                  <i class="fa fa-info-circle"></i> Click "Set as Cover" to select the cover image
                                </small>
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <div class="">
                                <base-progress
                                  type="success"
                                  :value="uploadPercentage"
                                  label="File uploaded"
                                ></base-progress>
                                <input
                                  type="file"
                                  ref="file1"
                                  accept="image/*"
                                  id="addimage"
                                  placeholder="User DP"
                                  class="form-control form-control-alternative"
                                  multiple="multiple"
                                  @change="addhadleimage($event, 'add', 'file')"
                                />
                                <div
                                  v-if="$v.model.item_img.$error"
                                  class="error h5 text-danger mt-2 pl-1"
                                >
                                  Field is required.
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="row">
                                <div
                                  class="col-lg-4 mb-3"
                                  v-for="(img, index) in model.item_img"
                                  :key="index"
                                >
                                  <div class="position-relative" style="position: relative;">
                                    <span
                                      class="delete-image cursor-pointer"
                                      @click="deleteimage(index)"
                                      ><i class="fa fa-trash text-white"></i
                                    ></span>
                                    <img
                                      v-if="img"
                                      :src="img"
                                      class="rounded shadow img-fluid"
                                      :class="{ 'border border-success border-3': coverImageIndex === index }"
                                    />
                                    <div
                                      v-if="coverImageIndex === index"
                                      class="position-absolute"
                                      style="top: 10px; right: 10px; background: #28a745; color: white; padding: 4px 8px; border-radius: 4px; font-size: 12px; font-weight: bold;"
                                    >
                                      <i class="fa fa-star"></i> Cover
                                    </div>
                                    <div
                                      v-else
                                      class="position-absolute"
                                      style="top: 10px; right: 10px;"
                                    >
                                      <base-button
                                        type="success"
                                        size="sm"
                                        @click="setCoverImage(index)"
                                        icon="fa fa-star"
                                      >
                                        Set as Cover
                                      </base-button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <hr class="dashed" />
                            </div>
                            <div class="col-md-12 mb-2">
                              Business tagging
                            </div>
                            <div class="col-lg-12 mb-2">
                              <label class="form-control-label">Business User</label>
                              <select
                                v-model="model.user_id"
                                aria-describedby="addon-right addon-left"
                                addon-left-icon="ni ni-bullet-list-67"
                                class="form-control form-control-alternative"
                                autocomplete="off"
                                @change="getprojectdata()"
                              >
                                <option value="">
                                  Select Business
                                </option>
                                <option
                                  v-for="(collections,
                                  index) in businessuserdata"
                                  :key="index"
                                  :value="collections._id"
                                >
                                  {{ collections.business_name_english }}
                                </option>
                              </select>
                            </div>
                            <div class="col-lg-12">
                              <label class="form-control-label">Projects</label>
                              <select
                                aria-describedby="addon-right addon-left"
                                addon-left-icon="ni ni-bullet-list-67"
                                v-model="model.project_id"
                                class="form-control form-control-alternative"
                                autocomplete="off"
                              >
                                <option value="">
                                  Select folder
                                </option>
                                <option
                                  v-for="(collections, index) in collectionData"
                                  :key="index"
                                  :value="collections.project_id"
                                >
                                  {{ collections.project_name }}
                                </option>
                              </select>
                              <div
                                v-if="$v.model.project_id.$error"
                                class="error h5 text-danger mt-2 pl-1"
                              >
                                Field is required.
                              </div>
                            </div>
                            <div class="col-lg-12">
                              <base-button
                                id="sendnoti"
                                size="lg"
                                @click="createcollectionwindow()"
                                type="primary"
                                icon="fa fa-plus"
                                class="float-center"
                                block
                              >
                                Create new project
                              </base-button>
                            </div>
                            <div class="col-md-12">
                              <hr class="dashed" />
                            </div>
                            <div class="col-md-12 mb-2">
                              Categorization
                            </div>
                            <div class="col-lg-12 mb-2">
                              <div class="d-flex justify-content-between align-items-center mb-1">
                                <label class="form-control-label mb-0"
                                  >Select category <span class="text-danger">*</span></label
                                >
                                <base-button
                                  type="primary"
                                  size="sm"
                                  icon="fa fa-plus"
                                  @click="openCategoryModal"
                                >
                                  Add New
                                </base-button>
                              </div>
                              <select
                                aria-describedby="addon-right addon-left"
                                addon-left-icon="ni ni-bullet-list-67"
                                v-model="model.item_category"
                                class="form-control"
                                :class="{ 'is-invalid': categoriesError }"
                                autocomplete="off"
                                @change="getsubcategoriesadd()"
                                :disabled="loadingCategories"
                              >
                                <option value="">
                                  {{ loadingCategories ? 'Loading categories...' : 'Select category' }}
                                </option>
                                <option
                                  v-for="category in categories"
                                  :key="category._id"
                                  :value="category._id"
                                >
                                  {{ category.inventory_category_name }}
                                </option>
                              </select>
                              <small v-if="categoriesError" class="text-danger">{{ categoriesError }}</small>
                              <small v-if="categories.length === 0 && !loadingCategories" class="text-muted">No categories available</small>
                            </div>
                            <div class="col-lg-12 mb-2">
                              <div class="d-flex justify-content-between align-items-center mb-1">
                                <label class="form-control-label mb-0"
                                  >Select sub-category</label
                                >
                                <base-button
                                  type="primary"
                                  size="sm"
                                  icon="fa fa-plus"
                                  @click="openSubcategoryModal"
                                  :disabled="!model.item_category"
                                >
                                  Add New
                                </base-button>
                              </div>
                              <select
                                aria-describedby="addon-right addon-left"
                                addon-left-icon="ni ni-bullet-list-67"
                                v-model="model.item_subcategory"
                                class="form-control"
                                :class="{ 'is-invalid': subcategoriesError }"
                                autocomplete="off"
                                :disabled="loadingSubcategories || !model.item_category"
                              >
                                <option value="">
                                  {{ loadingSubcategories ? 'Loading subcategories...' : model.item_category ? 'Select sub-category' : 'Select category first' }}
                                </option>
                                <option
                                  v-for="subcategory in subcategories"
                                  :key="subcategory._id"
                                  :value="subcategory._id"
                                >
                                  {{ subcategory.inventory_subcategory_name }}
                                </option>
                              </select>
                              <small v-if="subcategoriesError" class="text-danger">{{ subcategoriesError }}</small>
                              <small v-if="subcategories.length === 0 && !loadingSubcategories && model.item_category" class="text-muted">No subcategories available for this category</small>
                            </div>
                            <div class="col-md-12">
                              <hr class="dashed" />
                            </div>
                            <div class="col-md-12 mb-2">
                              Other Details
                            </div>
                            <div
                              class="col-lg-12 mb-2"
                              v-if="model.item_type == 'Product'"
                            >
                              <div class="row">
                                <div class="col-lg-4">
                                  <label class="form-control-label"
                                    >Currency</label
                                  >
                                  <select
                                    aria-describedby="addon-right addon-left"
                                    addon-left-icon="ni ni-bullet-list-67"
                                    v-model="model.item_space"
                                    class="form-control"
                                    autocomplete="off"
                                  >
                                    <option value="">
                                      Select currency
                                    </option>
                                    <option>
                                      BHD
                                    </option>
                                    <option>
                                      OMR
                                    </option>
                                  </select>
                                </div>
                                <div class="col-lg-4">
                                  <label class="form-control-label"
                                    >Product Cost</label
                                  >
                                  <base-input
                                    v-model="model.item_cost"
                                    placeholder="type here"
                                    class="mb-0"
                                  />
                                </div>
                                <div class="col-lg-4">
                                  <div class="d-flex justify-content-between align-items-center mb-1">
                                    <label class="form-control-label mb-0"
                                      >Brand</label
                                    >
                                    <base-button
                                      type="primary"
                                      size="sm"
                                      icon="fa fa-plus"
                                      @click="openBrandModal"
                                    >
                                      Add New
                                    </base-button>
                                  </div>
                                  <select
                                    aria-describedby="addon-right addon-left"
                                    addon-left-icon="ni ni-bullet-list-67"
                                    v-model="model.item_brand"
                                    class="form-control"
                                    :class="{ 'is-invalid': brandsError }"
                                    autocomplete="off"
                                    :disabled="loadingBrands"
                                  >
                                    <option value="" disabled="">
                                      {{ loadingBrands ? 'Loading brands...' : 'Select brand' }}
                                    </option>
                                    <option
                                      v-for="brand in brands"
                                      :value="brand.value_en"
                                      :key="brand.value_en"
                                    >
                                      {{ brand.value_en + (brand.value_ar ? ' (' + brand.value_ar + ')' : '') }}
                                    </option>
                                  </select>
                                  <small v-if="brandsError" class="text-danger">{{ brandsError }}</small>
                                  <small v-if="brands.length === 0 && !loadingBrands" class="text-muted">No brands available</small>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-12 mb-2">
                              <label class="form-control-label">Add Tags</label>
                              <!-- Simple tag input as fallback until vue-multiselect is fixed -->
                              <div class="tag-input-wrapper">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="Type tag and press Enter, or select from dropdown"
                                  @keyup.enter="addTagFromInput($event)"
                                  list="tagOptions"
                                />
                                <datalist id="tagOptions">
                                  <option v-for="tag in tagData" :key="tag._id" :value="tag.tag">
                                    {{ tag.tag }}
                                  </option>
                                </datalist>
                                <!-- Display selected tags -->
                                <div v-if="model.item_tags && model.item_tags.length > 0" class="mt-2">
                                  <span
                                    v-for="(tag, index) in model.item_tags"
                                    :key="index"
                                    class="badge badge-primary mr-2 mb-2"
                                    style="font-size: 0.875rem; padding: 0.5rem;"
                                  >
                                    {{ tag.tag }}
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-link text-white p-0 ml-1"
                                      @click="removeTag(index)"
                                      style="font-size: 1.2rem; line-height: 1;"
                                    >
                                      ×
                                    </button>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 mb-2">
                              <label class="form-control-label"
                                >Search Users</label
                              >
                              <multiselect
                                aria-describedby="addon-right addon-left"
                                v-model="model.item_mentions"
                                tag-placeholder="Search users"
                                placeholder="Select user"
                                label="business_name_english"
                                track-by="_id"
                                :options="userData"
                                :multiple="true"
                                :taggable="true"
                              ></multiselect>
                            </div>
                            <div class="col-lg-12">
                              <base-button
                                type="primary"
                                id="saveuserbtn"
                                :disabled="$v.model.$error"
                                @click="
                                  $v.model.$touch();
                                  saveitem();
                                "
                                >Save Item</base-button
                              >
                            </div>
                            <!-- business hours end here-->
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </tab-pane>
        </div>
      </tabs>
    </div>
    <!-- view comments modal -->
    <modal :show.sync="modals.editproduct" class="bg-white full-modal">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Edit
      </h6>
      <template>
        <form @submit.prevent>
          <div class="row py-3 card shadow">
            <div class="col-md-12">
              <p class="border-bottom">Basic Details</p>
            </div>
            <div class="col-lg-12">
              <base-input
                alternative=""
                label="Item Name"
                placeholder="Item Name"
                input-classes="form-control-alternative"
                v-model="modals.item_name"
              />
              <div
                v-if="$v.modals.item_name.$error"
                class="error h5 text-danger mt--4 pl-1"
              >
                Field is required.
              </div>
            </div>
            <div class="col-lg-12">
              <base-input
                alternative=""
                label="Item Name Arabic"
                placeholder="Item Name Arabic"
                type="text"
                input-classes="form-control-alternative"
                v-model="modals.item_name_ar"
              />
            </div>
            <div class="col-lg-12">
              <base-input
                alternative=""
                label="Item Description (English)"
                placeholder="Item Description (English)"
                input-classes="form-control-alternative"
                v-model="modals.item_description"
              />
            </div>
            <div class="col-lg-12">
              <base-input
                alternative=""
                label="Item Description (Arabic)"
                placeholder="Item Description (Arabic)"
                input-classes="form-control-alternative"
                v-model="modals.item_description_ar"
              />
            </div>
          </div>
          <div class="row py-3 card shadow mt-3">
            <div class="col-md-12">
              <p class="border-bottom mb-0">Upload Image</p>
            </div>
            <div class="col-lg-12">
              <div class="div">
                <base-progress
                  type="success"
                  :value="uploadPercentage"
                  label="File uploaded"
                ></base-progress>
                <input
                  type="file"
                  ref="file2"
                  accept="image/*"
                  placeholder="User DP"
                  class="form-control form-control-alternative"
                  multiple="multiple"
                  @change="edithadleimage($event, 'add', 'file')"
                />
                <div
                  v-if="$v.modals.item_img.$error"
                  class="error h5 text-danger mt-2 pl-1"
                >
                  Field is required.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row mt-3">
                <div
                  class="col-lg-4 mb-3"
                  v-for="(img, index) in modals.item_img"
                  :key="img"
                >
                  <div class="position-relative" style="position: relative;">
                    <span
                      class="delete-image cursor-pointer"
                      @click="editdeleteimage(index)"
                      ><i class="fa fa-trash text-white"></i
                    ></span>
                    <img
                      v-if="img"
                      :src="img"
                      class="rounded shadow img-fluid"
                      :class="{ 'border border-success border-3': editCoverImageIndex === index }"
                    />
                    <div
                      v-if="editCoverImageIndex === index"
                      class="position-absolute"
                      style="top: 10px; right: 10px; background: #28a745; color: white; padding: 4px 8px; border-radius: 4px; font-size: 12px; font-weight: bold;"
                    >
                      <i class="fa fa-star"></i> Cover
                    </div>
                    <div
                      v-else
                      class="position-absolute"
                      style="top: 10px; right: 10px;"
                    >
                      <base-button
                        type="success"
                        size="sm"
                        @click="setEditCoverImage(index)"
                        icon="fa fa-star"
                      >
                        Set as Cover
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row py-3 card shadow mt-3">
            <div class="col-md-12">
              <p class="border-bottom mb-2">
                Business User Details
              </p>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Bisiness User</label>
              <select
                aria-describedby="addon-right addon-left"
                addon-left-icon="ni ni-bullet-list-67"
                v-model="modals.user_id"
                class="form-control form-control-alternative"
                autocomplete="off"
                @change="editgetprojectdata()"
              >
                <option value="">
                  Select Business
                </option>
                <option
                  v-for="(collections, index) in businessuserdata"
                  :key="index"
                  :value="collections._id"
                >
                  {{ collections.business_name_english }}
                </option>
              </select>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Projects</label>
              <select
                aria-describedby="addon-right addon-left"
                addon-left-icon="ni ni-bullet-list-67"
                v-model="modals.project_id"
                class="form-control form-control-alternative"
                autocomplete="off"
              >
                <option value="">
                  Select folder
                </option>
                <option
                  v-for="(collections, index) in collectionData"
                  :key="index"
                  :value="collections.project_id"
                >
                  {{ collections.project_name }}
                </option>
              </select>
              <div
                v-if="$v.modals.project_id.$error"
                class="error h5 text-danger mt-2 pl-1"
              >
                Field is required.
              </div>
            </div>
            <div class="col-lg-12">
              <base-button
                id="sendnoti"
                size="lg"
                @click="createcollectionwindow()"
                type="primary"
                icon="fa fa-plus"
                class="float-center"
                block
              >
                Create new project
              </base-button>
            </div>
          </div>
          <div class="row py-3 card shadow mt-3">
            <div class="col-md-12">
              <p class="border-bottom mb-2">Additional Details</p>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Select category</label>
              <select
                aria-describedby="addon-right addon-left"
                addon-left-icon="ni ni-bullet-list-67"
                v-model="modals.item_category"
                class="form-control"
                :class="{ 'is-invalid': categoriesError }"
                autocomplete="off"
                @change="editgetsubcategoriesadd()"
                :disabled="loadingCategories"
              >
                <option value="">
                  {{ loadingCategories ? 'Loading categories...' : 'Select category' }}
                </option>
                <option
                  v-for="category in categories"
                  :key="category._id"
                  :value="category._id"
                >
                  {{ category.inventory_category_name }}
                </option>
              </select>
              <small v-if="categoriesError" class="text-danger">{{ categoriesError }}</small>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Select sub-category</label>
              <select
                aria-describedby="addon-right addon-left"
                addon-left-icon="ni ni-bullet-list-67"
                v-model="modals.item_subcategory"
                class="form-control"
                :class="{ 'is-invalid': subcategoriesError }"
                autocomplete="off"
                :disabled="loadingSubcategories || !modals.item_category"
              >
                <option value="">
                  {{ loadingSubcategories ? 'Loading subcategories...' : modals.item_category ? 'Select sub-category' : 'Select category first' }}
                </option>
                <option
                  v-for="subcategory in subcategories"
                  :key="subcategory._id"
                  :value="subcategory._id"
                >
                  {{ subcategory.inventory_subcategory_name }}
                </option>
              </select>
              <small v-if="subcategoriesError" class="text-danger">{{ subcategoriesError }}</small>
              <small v-if="subcategories.length === 0 && !loadingSubcategories && modals.item_category" class="text-muted">No subcategories available</small>
            </div>
            <div class="col-lg-12">
              <div
                class="row justify-content-center"
                v-if="modals.item_type == 'Product'"
              >
                <div class="col-lg-4">
                  <label class="form-control-label">Currency</label>
                  <select
                    aria-describedby="addon-right addon-left"
                    addon-left-icon="ni ni-bullet-list-67"
                    v-model="modals.item_space"
                    class="form-control"
                    autocomplete="off"
                  >
                    <option value="">
                      Select currency
                    </option>
                    <option>
                      BHD
                    </option>
                    <option>
                      OMR
                    </option>
                  </select>
                </div>
                <div class="col-lg-12">
                  <div
                    class="row justify-content-center"
                    v-if="modals.item_type == 'Product'"
                  >
                    <div class="col-lg-4">
                      <label class="form-control-label">Currency</label>
                      <select
                        aria-describedby="addon-right addon-left"
                        addon-left-icon="ni ni-bullet-list-67"
                        v-model="modals.item_space"
                        class="form-control"
                        autocomplete="off"
                      >
                        <option value="">
                          Select currency
                        </option>
                        <option>
                          BHD
                        </option>
                        <option>
                          OMR
                        </option>
                      </select>
                    </div>
                    <div class="col-lg-4">
                      <label class="form-control-label">Product Cost</label>
                      <base-input
                        v-model="modals.item_cost"
                        placeholder="type here"
                        class="mb-0"
                      />
                    </div>
                    <div class="col-lg-4">
                      <label class="form-control-label">Brand</label>
                      <select
                        aria-describedby="addon-right addon-left"
                        addon-left-icon="ni ni-bullet-list-67"
                        v-model="modals.item_brand"
                        class="form-control"
                        :class="{ 'is-invalid': brandsError }"
                        autocomplete="off"
                        :disabled="loadingBrands"
                      >
                        <option value="" disabled="">
                          {{ loadingBrands ? 'Loading brands...' : 'Select brand' }}
                        </option>
                        <option
                          v-for="brand in brands"
                          :value="brand.value_en"
                          :key="brand.value_en"
                        >
                          {{ brand.value_en + (brand.value_ar ? ' (' + brand.value_ar + ')' : '') }}
                        </option>
                      </select>
                      <small v-if="brandsError" class="text-danger">{{ brandsError }}</small>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-lg-12">
                        <label class="form-control-label">Add Tags</label>
                        
                        <multiselect  aria-describedby="addon-right addon-left" v-model="modals.item_tags" tag-placeholder="Add Tag" placeholder="Search tag" label="tag" track-by="tag" :options="tagData" :multiple="true" :taggable="true" @tag="editTag" ></multiselect>
                        
                    </div>
                    <div class="col-md-12 mb-2">
                      <label class="form-control-label">Search Users</label>
                        <multiselect  aria-describedby="addon-right addon-left" v-model="modals.item_mentions" tag-placeholder="Search users" placeholder="Select user" label="business_name_english" track-by="_id" :options="userData" :multiple="true" :taggable="true" ></multiselect>
                    </div> -->
                <!-- business hours end here-->
              </div>
              <!-- <div class="row mt-3">
                    <div class="col-lg-12">
                      <base-button type="primary" id="updateuserbtn" :disabled="$v.modals.$error" @click="$v.modals.$touch();updateitem()">Update Item</base-button>
                    </div>
                  </div> -->
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Add Tags</label>

              <multiselect
                aria-describedby="addon-right addon-left"
                v-model="modals.item_tags"
                tag-placeholder="Add Tag"
                placeholder="Search tag"
                label="tag"
                track-by="tag"
                :options="tagData"
                :multiple="true"
                :taggable="true"
                @tag="editTag"
              ></multiselect>

              <!-- Add More Tags Button -->
              <div class="mt-2">
                <base-button
                  type="secondary"
                  size="sm"
                  @click="showEditTagConfirmationModal"
                  icon="fa fa-plus"
                >
                  Add More Tags
                </base-button>
              </div>
            </div>
            <div class="col-md-12 mb-2">
              <label class="form-control-label">Search Users</label>
              <multiselect
                aria-describedby="addon-right addon-left"
                v-model="modals.item_mentions"
                tag-placeholder="Search users"
                placeholder="Select user"
                label="business_name_english"
                track-by="_id"
                :options="userData"
                :multiple="true"
                :taggable="true"
              ></multiselect>
            </div>
            <!-- business hours end here-->
          </div>
          <div class="row mt-3">
            <div class="col-lg-12">
              <base-button
                type="primary"
                id="updateuserbtn"
                :disabled="$v.modals.$error"
                @click="
                  $v.modals.$touch();
                  updateitem();
                "
                >Update Item</base-button
              >
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <!-- <base-button type="primary" id="updatebtn1" v-on:click="updateDesign()">Save changes</base-button> -->
        <base-button
          type="link"
          class="ml-auto"
          @click="modals.editproduct = false"
          >Close
        </base-button>
      </template>
    </modal>

    <modal :show.sync="createcollection">
      <p id="modal-title-default" slot="header" class="modal-title">
        New projects
      </p>
      <template>
        <form @submit.prevent>
          <div class="row justify-content-center">
            <div class="col-lg-8 mb-3">
              <label class="form-control-label">Project Title</label>
              <base-input
                placeholder="Collection Title"
                v-model="collection.project_name"
                addon-left-icon="fa fa-commenting-o"
                class="form-control-alternative"
              />
            </div>
            <div class="col-lg-8">
              <label class="form-control-label">Project Description</label>
              <base-input
                placeholder="'Enter description"
                addon-left-icon="fa fa-commenting"
                v-model="collection.project_description"
                class="form-control-alternative"
              />
            </div>
          </div>
          <div class="row justify-content-center mt-4">
            <div class="col-lg-8">
              <base-button
                @click="saveprojects()"
                id="savecollectionbtn"
                size="lg"
                type="success"
                icon="fa fa-plus"
                class="float-center"
              >
                Save
              </base-button>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto mt--3"
          @click="createcollection = false"
        >
          Close
        </base-button>
      </template>
    </modal>

    <!-- Tag Confirmation Modal -->
    <modal :show.sync="tagConfirmationModal.show">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Add Tags to Your Product
      </h6>
      <template>
        <div class="row">
          <div class="col-12">
            <p class="text-muted">
              Would you like to add tags to your product? Tags help users find
              your product more easily.
            </p>
          </div>
        </div>
      </template>

      <template slot="footer">
        <base-button type="primary" @click="showTagInputModal">
          Yes, Add Tags
        </base-button>
        <base-button type="link" class="ml-auto" @click="skipTagCreation">
          Skip for Now
        </base-button>
      </template>
    </modal>

    <!-- Tag Input Modal -->
    <modal :show.sync="tagInputModal.show">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Add Tags
      </h6>
      <template>
        <div class="row">
          <div class="col-12">
            <label class="form-control-label">Add Tags</label>
            <p class="text-muted small">Available tags: {{ tagData.length }}</p>
            <p class="text-muted small">
              Selected tags:
              {{
                tagInputModal.selectedTags
                  ? tagInputModal.selectedTags.length
                  : 0
              }}
            </p>

            <!-- Simple input for adding tags -->
            <div class="mb-2">
              <input
                type="text"
                class="form-control"
                placeholder="Type a tag and press Enter to create"
                @keyup.enter="createTagFromInput"
                v-model="tagInputModal.newTagInput"
              />
              <small class="text-muted"
                >Press Enter to create tag immediately</small
              >

              <!-- Test button to verify method works -->
              <div class="mt-2">
                <button
                  type="button"
                  class="btn btn-sm btn-secondary"
                  @click="createTagFromInput"
                >
                  Test Create Tag
                </button>
              </div>
            </div>

            <!-- Previous tags list for quick selection -->
            <div class="mb-3" v-if="tagData.length > 0">
              <label class="form-control-label"
                >Previous Tags (Click to Add):</label
              >
              <div class="d-flex flex-wrap">
                <span
                  v-for="tag in tagData"
                  :key="tag._id"
                  class="badge badge-secondary mr-2 mb-2 cursor-pointer"
                  @click="selectExistingTag(tag)"
                  style="cursor: pointer;"
                >
                  {{ tag.tag }}
                </span>
              </div>
            </div>

            <!-- Multiselect for existing tags -->
            <multiselect
              v-model="tagInputModal.selectedTags"
              tag-placeholder="Add this as new tag"
              placeholder="Type to search or add new tags..."
              label="tag"
              track-by="tag"
              :options="tagData"
              :multiple="true"
              :taggable="true"
              @tag="selectTagFromMultiselect"
            ></multiselect>

            <!-- Display selected tags -->
            <div
              class="mt-3"
              v-if="
                tagInputModal.selectedTags &&
                  tagInputModal.selectedTags.length > 0
              "
            >
              <h6>Selected Tags:</h6>
              <div class="d-flex flex-wrap">
                <span
                  v-for="(tag, index) in tagInputModal.selectedTags"
                  :key="index"
                  class="badge badge-primary mr-2 mb-2"
                >
                  {{ tag.tag }}
                  <button
                    type="button"
                    class="btn btn-sm btn-link text-white p-0 ml-1"
                    @click="removeTagFromInputModal(index)"
                  >
                    ×
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <base-button type="link" class="ml-auto" @click="resetTagModals">
          Close
        </base-button>
      </template>
    </modal>

    <!-- Add Category Modal -->
    <modal :show.sync="showCategoryModal">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Add New Category
      </h6>
      <template>
        <form @submit.prevent="saveCategory">
          <div class="row">
            <div class="col-lg-12 mb-3">
              <label class="form-control-label">Category Name (English) <span class="text-danger">*</span></label>
              <base-input
                v-model="newCategory.inventory_category_name"
                placeholder="Enter category name in English"
                class="mb-0"
                required
              />
            </div>
            <div class="col-lg-12 mb-3">
              <label class="form-control-label">Category Name (Arabic)</label>
              <base-input
                v-model="newCategory.inventory_category_name_ar"
                placeholder="Enter category name in Arabic"
                class="mb-0"
              />
            </div>
          </div>
        </form>
      </template>
      <template slot="footer">
        <base-button type="primary" @click="saveCategory">
          Save Category
        </base-button>
        <base-button type="link" class="ml-auto" @click="showCategoryModal = false">
          Close
        </base-button>
      </template>
    </modal>

    <!-- Add Subcategory Modal -->
    <modal :show.sync="showSubcategoryModal">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Add New Subcategory
      </h6>
      <template>
        <form @submit.prevent="saveSubcategory">
          <div class="row">
            <div class="col-lg-12 mb-3">
              <label class="form-control-label">Category</label>
              <select
                v-model="newSubcategory.inventory_category_oid"
                class="form-control"
                :disabled="!!model.item_category"
                required
              >
                <option value="">Select category</option>
                <option
                  v-for="category in categories"
                  :key="category._id"
                  :value="category._id"
                >
                  {{ category.inventory_category_name }}
                </option>
              </select>
              <small class="text-muted" v-if="model.item_category">Using selected category from form</small>
            </div>
            <div class="col-lg-12 mb-3">
              <label class="form-control-label">Subcategory Name (English) <span class="text-danger">*</span></label>
              <base-input
                v-model="newSubcategory.inventory_subcategory_name"
                placeholder="Enter subcategory name in English"
                class="mb-0"
                required
              />
            </div>
            <div class="col-lg-12 mb-3">
              <label class="form-control-label">Subcategory Name (Arabic)</label>
              <base-input
                v-model="newSubcategory.inventory_subcategory_name_ar"
                placeholder="Enter subcategory name in Arabic"
                class="mb-0"
              />
            </div>
          </div>
        </form>
      </template>
      <template slot="footer">
        <base-button type="primary" @click="saveSubcategory">
          Save Subcategory
        </base-button>
        <base-button type="link" class="ml-auto" @click="showSubcategoryModal = false">
          Close
        </base-button>
      </template>
    </modal>

    <!-- Add Brand Modal -->
    <modal :show.sync="showBrandModal">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Add New Brand
      </h6>
      <template>
        <form @submit.prevent="saveBrand">
          <div class="row">
            <div class="col-lg-12 mb-3">
              <label class="form-control-label">Brand Name (English) <span class="text-danger">*</span></label>
              <base-input
                v-model="newBrand.value_en"
                placeholder="Enter brand name in English"
                class="mb-0"
                required
              />
            </div>
            <div class="col-lg-12 mb-3">
              <label class="form-control-label">Brand Name (Arabic)</label>
              <base-input
                v-model="newBrand.value_ar"
                placeholder="Enter brand name in Arabic"
                class="mb-0"
              />
            </div>
          </div>
        </form>
      </template>
      <template slot="footer">
        <base-button type="primary" @click="saveBrand">
          Save Brand
        </base-button>
        <base-button type="link" class="ml-auto" @click="showBrandModal = false">
          Close
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import axios from 'axios';
import VueSwal from 'vue-swal';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { compressImageIfNeeded } from '../utils/imageCompression';
import {
  required,
  minLength,
  between,
  integer,
  minValue,
} from 'vuelidate/lib/validators';
export default {
  name: 'tables',
  components: { Multiselect },
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  data() {
    return {
      search: '',
      searchData: [],
      categories: [],
      collectionData: [],
      businessuserdata: [],
      imagearr: [],
      editimagearr: [],
      userData: [],
      createcollection: false,
      uploadPercentage: 0,
      tagData: [],
      deleteitem: false,
      tagConfirmationModal: {
        show: false,
      },
      tagInputModal: {
        show: false,
        selectedTags: [],
        newTagInput: '',
        createdInventoryId: '',
        createdBy: '',
      },
      subcategories: [],
      brands: [],
      productData: [],
      reportedcaption: [],
      offset: 0,
      u_offset: 0,
      r_offset: 0,
      // Loading states
      loadingCategories: false,
      loadingSubcategories: false,
      loadingBrands: false,
      loadingProducts: false,
      // Error states
      categoriesError: null,
      subcategoriesError: null,
      brandsError: null,
      // Cover image selection
      coverImageIndex: 0, // Index of cover image in add mode
      editCoverImageIndex: 0, // Index of cover image in edit mode
      // Modals for creating category, subcategory, brand
      showCategoryModal: false,
      showSubcategoryModal: false,
      showBrandModal: false,
      newCategory: {
        inventory_category_name: '',
        inventory_category_name_ar: '',
        status: 'approved',
        created_by: '',
      },
      newSubcategory: {
        inventory_subcategory_name: '',
        inventory_subcategory_name_ar: '',
        inventory_category_oid: '',
        status: 'approved',
        created_by: '',
      },
      newBrand: {
        value_en: '',
        value_ar: '',
      },
      modals: {
        editproduct: false,
        stats: false,
        item_name: '',
        item_name_ar: '',
        item_description_ar: '',
        item_description: '',
        item_type: 'Product',
        item_visibility: 'Public',
        item_category: '',
        item_subcategory: '',
        item_space: '',
        item_brand: '',
        item_cost: '',
        item_theme_color: '',
        item_tags: [],
        optype: 'Add',
        item_img: '',
        item_mentions: '',
        item_rate: '',
        created_by: '',
        status: 'approved',
      },
      collection: {
        project_name: '',
        project_description: '',
        collection_type: '',
        status: 'approved',
        created_by: '',
      },
      model: {
        item_name: '',
        item_name_ar: '',
        item_description_ar: '',
        item_description: '',
        item_type: 'Product',
        item_visibility: 'Public',
        item_category: '',
        item_subcategory: '',
        item_space: '',
        item_brand: '',
        item_cost: '',
        item_theme_color: '',
        item_tags: [],
        optype: 'Add',
        item_img: '',
        item_mentions: '',
        item_rate: '',
        created_by: '',
        status: 'approved',
      },
      status: {
        0: { val: 'approved' },
        1: { val: 'rejected' },
        2: { val: 'pending' },
        3: { val: 'suspended' },
      },
      auth: {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'nabnee#' + localStorage.getItem('accessToken'),
          _id: localStorage.getItem('_id'),
        },
      },
      auth1: {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: 'nabnee#' + localStorage.getItem('accessToken'),
          _id: localStorage.getItem('_id'),
        },
      },
    };
  },
  validations: {
    model: {
      item_name: {
        required,
      },
      project_id: {
        required,
      },
      item_img: {
        required,
      },
    },
    modals: {
      item_name: {
        required,
      },
      project_id: {
        required,
      },
      item_img: {
        required,
      },
    },
  },
  mounted() {
    this.path = process.env.VUE_APP_API_ENDPOINT;
    const querystring = require('querystring');
    console.log(this.auth);
    axios
      .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_all', {
        details: { item_type: 'Product' },
        offset: '0',
      })
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.productData = response.data.details;
        }
      });

    axios
      .post(process.env.VUE_APP_API_ENDPOINT + 'read_businessuser_all', {
        details: { user_type: 'Business' },
        offset: '0',
      })
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          this.businessuserdata = response.data.details;
        }
      });

    axios
      .post(
        process.env.VUE_APP_API_ENDPOINT + 'read_businessuser_all',
        { details: {}, offset: '0' },
        this.auth
      )
      .then((response) => {
        console.log(response);
        if (response.data.details) {
          let userData = response.data.details;
          for (var i = 0; i < userData.length; i++) {
            if (userData[i].business_name_english) {
              this.userData.push({
                _id: userData[i]._id,
                business_name_english: userData[i].business_name_english,
              });
            }
          }
          console.log(this.userData);
        }
      });
    console.log('[TAGS] Loading tags...');
    axios
      .post(process.env.VUE_APP_API_ENDPOINT + 'read_tag_all', {}, this.auth)
      .then((response) => {
        console.log('[TAGS] API response received:', response);
        if (response.data && response.data.details) {
          this.tagData = response.data.details;
          console.log('[TAGS] Loaded', this.tagData.length, 'tags');
        } else {
          this.tagData = [];
          console.log('[TAGS] No tags in response');
        }
      })
      .catch((error) => {
        console.error('[TAGS] Error loading tags:', error);
        this.tagData = [];
      });

    // Load categories
    this.loadCategories();

    // Load brands
    this.loadBrands();
  },
  methods: {
    // Load categories with proper error handling
    loadCategories() {
      this.loadingCategories = true;
      this.categoriesError = null;
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_category', {
          status: 'approved',
        })
        .then((response) => {
          console.log('Categories loaded:', response);
          if (response.data && response.data.details) {
            // Filter out Design category and sort alphabetically
            this.categories = response.data.details
              .filter(
                (category) => category.inventory_category_name !== 'Design'
              )
              .sort((a, b) => {
                const nameA = (a.inventory_category_name || '').toLowerCase();
                const nameB = (b.inventory_category_name || '').toLowerCase();
                return nameA.localeCompare(nameB);
              });
            console.log('Filtered categories:', this.categories);
          } else {
            this.categories = [];
            console.warn('No categories found in response');
          }
        })
        .catch((error) => {
          console.error('Error loading categories:', error);
          this.categoriesError = 'Failed to load categories. Please try again.';
          this.categories = [];
        })
        .finally(() => {
          this.loadingCategories = false;
        });
    },

    // Load subcategories for selected category
    loadSubcategories(categoryId, isEditMode = false) {
      if (!categoryId) {
        this.subcategories = [];
        if (isEditMode) {
          this.modals.item_subcategory = '';
        } else {
          this.model.item_subcategory = '';
        }
        return;
      }

      this.loadingSubcategories = true;
      this.subcategoriesError = null;
      const querystring = require('querystring');
      
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'read_inventory_subcategory',
          querystring.stringify({
            inventory_category_oid: categoryId,
          }),
          this.auth1
        )
        .then((response) => {
          console.log('Subcategories loaded:', response);
          if (response.data && response.data.details) {
            // Sort subcategories alphabetically
            this.subcategories = response.data.details.sort((a, b) => {
              const nameA = (a.inventory_subcategory_name || '').toLowerCase();
              const nameB = (b.inventory_subcategory_name || '').toLowerCase();
              return nameA.localeCompare(nameB);
            });
            console.log('Filtered subcategories:', this.subcategories);
            
            // Reset subcategory selection when category changes
            if (isEditMode) {
              this.modals.item_subcategory = '';
            } else {
              this.model.item_subcategory = '';
            }
          } else {
            this.subcategories = [];
            console.warn('No subcategories found for category:', categoryId);
          }
        })
        .catch((error) => {
          console.error('Error loading subcategories:', error);
          this.subcategoriesError = 'Failed to load subcategories. Please try again.';
          this.subcategories = [];
        })
        .finally(() => {
          this.loadingSubcategories = false;
        });
    },

    // Open modals
    openCategoryModal() {
      this.newCategory = {
        inventory_category_name: '',
        inventory_category_name_ar: '',
        status: 'approved',
        created_by: localStorage.getItem('_id') || '',
      };
      this.showCategoryModal = true;
    },

    openSubcategoryModal() {
      this.newSubcategory = {
        inventory_subcategory_name: '',
        inventory_subcategory_name_ar: '',
        inventory_category_oid: this.model.item_category || '',
        status: 'approved',
        created_by: localStorage.getItem('_id') || '',
      };
      this.showSubcategoryModal = true;
    },

    openBrandModal() {
      this.newBrand = {
        value_en: '',
        value_ar: '',
      };
      this.showBrandModal = true;
    },

    // Save new category
    saveCategory() {
      if (!this.newCategory.inventory_category_name) {
        alert('Please enter category name');
        return;
      }

      const querystring = require('querystring');
      const categoryData = {
        inventory_category_name: this.newCategory.inventory_category_name,
        inventory_category_name_ar: this.newCategory.inventory_category_name_ar || '',
        status: 'approved',
        created_by: localStorage.getItem('_id') || '',
      };

      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'create_inventory_category',
          querystring.stringify(categoryData),
          this.auth1
        )
        .then((response) => {
          console.log('Category created:', response);
          if (response.data && response.data.success !== false) {
            alert('Category created successfully!');
            this.showCategoryModal = false;
            // Reload categories
            this.loadCategories();
            // Optionally select the newly created category
            if (response.data.details && response.data.details._id) {
              this.model.item_category = response.data.details._id;
              this.getsubcategoriesadd();
            }
          } else {
            alert('Failed to create category: ' + (response.data.message || 'Unknown error'));
          }
        })
        .catch((error) => {
          console.error('Error creating category:', error);
          alert('Error creating category: ' + (error.response && error.response.data && error.response.data.message || error.message));
        });
    },

    // Save new subcategory
    saveSubcategory() {
      if (!this.newSubcategory.inventory_subcategory_name) {
        alert('Please enter subcategory name');
        return;
      }

      const categoryId = this.model.item_category || this.newSubcategory.inventory_category_oid;
      if (!categoryId) {
        alert('Please select a category first');
        return;
      }

      const querystring = require('querystring');
      const subcategoryData = {
        inventory_subcategory_name: this.newSubcategory.inventory_subcategory_name,
        inventory_subcategory_name_ar: this.newSubcategory.inventory_subcategory_name_ar || '',
        inventory_category_oid: categoryId,
        status: 'approved',
        created_by: localStorage.getItem('_id') || '',
      };

      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'create_inventory_subcategory',
          querystring.stringify(subcategoryData),
          this.auth1
        )
        .then((response) => {
          console.log('Subcategory created:', response);
          if (response.data && response.data.success !== false) {
            alert('Subcategory created successfully!');
            this.showSubcategoryModal = false;
            // Reload subcategories
            this.loadSubcategories(categoryId, false);
            // Optionally select the newly created subcategory
            if (response.data.details && response.data.details._id) {
              this.model.item_subcategory = response.data.details._id;
            }
          } else {
            alert('Failed to create subcategory: ' + (response.data.message || 'Unknown error'));
          }
        })
        .catch((error) => {
          console.error('Error creating subcategory:', error);
          alert('Error creating subcategory: ' + (error.response && error.response.data && error.response.data.message || error.message));
        });
    },

    // Save new brand
    saveBrand() {
      console.log('[BRANDS] ========== saveBrand CALLED ==========');
      console.log('[BRANDS] New brand data:', this.newBrand);
      
      if (!this.newBrand.value_en) {
        alert('Please enter brand name');
        return;
      }

      // First, get the existing brand filter
      console.log('[BRANDS] Checking for existing brand filter...');
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_filter_all', {
          filters: { filter_name: 'brand' },
        })
        .then((response) => {
          console.log('[BRANDS] read_inventory_filter_all response:', response);
          console.log('[BRANDS] Response data:', response.data);
          
          if (response.data && response.data.details && response.data.details.length > 0) {
            const brandFilter = response.data.details[0];
            console.log('[BRANDS] Existing brand filter found:', brandFilter);
            
            // Try both filter_id and _id
            const filterId = brandFilter.filter_id || brandFilter._id;
            console.log('[BRANDS] Using filter_id:', filterId);
            
            // Check if brand already exists
            if (brandFilter.filter_values && Array.isArray(brandFilter.filter_values)) {
              console.log('[BRANDS] Current filter_values:', brandFilter.filter_values);
              const existingBrand = brandFilter.filter_values.find(
                (b) => b.value_en && b.value_en.toLowerCase() === this.newBrand.value_en.toLowerCase()
              );
              if (existingBrand) {
                console.log('[BRANDS] Brand already exists:', existingBrand);
                alert('Brand already exists!');
                return;
              }
            }

            // Use the update endpoint with optype: 'Add' format
            // Send as JSON, not querystring
            const updateData = {
                  filter_id: filterId,
                  filter_name: this.newBrand.value_en,
                  filter_name_ar: this.newBrand.value_ar || '',
                  optype: 'Add',
                  created_by: localStorage.getItem('_id') || '',
            };
            console.log('[BRANDS] Sending update request with data:', updateData);
            console.log('[BRANDS] Endpoint:', process.env.VUE_APP_API_ENDPOINT + 'update_inventory_filter');
            
            axios
              .post(
                process.env.VUE_APP_API_ENDPOINT + 'update_inventory_filter',
                updateData,
                this.auth
              )
              .then((updateResponse) => {
                console.log('[BRANDS] Update response:', updateResponse);
                console.log('[BRANDS] Update response data:', updateResponse.data);
                console.log('[BRANDS] Update response status:', updateResponse.status);
                
                if (updateResponse.data && updateResponse.data.success !== false) {
                  console.log('[BRANDS] Brand added successfully!');
                  // Save the brand name before clearing
                  const newBrandName = this.newBrand.value_en;
                  
                  // Update brands array directly from response
                  if (updateResponse.data.details && updateResponse.data.details.filter_values && Array.isArray(updateResponse.data.details.filter_values)) {
                    const sortedBrands = updateResponse.data.details.filter_values.sort((a, b) => {
                      const nameA = (a.value_en || '').toLowerCase();
                      const nameB = (b.value_en || '').toLowerCase();
                      return nameA.localeCompare(nameB);
                    });
                    // Use splice to ensure Vue reactivity
                    this.brands.splice(0, this.brands.length, ...sortedBrands);
                    console.log('[BRANDS] Updated brands array from response:', this.brands);
                    console.log('[BRANDS] Brands count:', this.brands.length);
                    console.log('[BRANDS] Brands array contents:', JSON.stringify(this.brands));
                    // Force Vue to update the UI
                    this.$forceUpdate();
                  }
                  
                  alert('Brand added successfully!');
                  this.showBrandModal = false;
                  this.newBrand.value_en = '';
                  this.newBrand.value_ar = '';
                  
                  // Select the newly created brand
                  this.$nextTick(() => {
                    this.model.item_brand = newBrandName;
                    console.log('[BRANDS] Set model.item_brand to:', newBrandName);
                    console.log('[BRANDS] Current brands in dropdown:', this.brands);
                  });
                } else {
                  console.error('[BRANDS] Failed to add brand. Response:', updateResponse.data);
                  alert('Failed to add brand: ' + (updateResponse.data && updateResponse.data.message || 'Unknown error'));
                }
              })
              .catch((error) => {
                console.error('[BRANDS] Error updating brand filter:', error);
                console.error('[BRANDS] Error response:', error.response);
                console.error('[BRANDS] Error message:', error.message);
                alert('Error adding brand: ' + (error.response && error.response.data && error.response.data.message || error.message));
              });
          } else {
            // No brand filter exists, create one
            console.log('[BRANDS] No brand filter exists, creating new one...');
            const newFilter = {
              filter_name: 'brand',
              filter_name_ar: 'ماركة',
              status: 'approved',
              created_by: localStorage.getItem('_id') || '',
            };
            console.log('[BRANDS] Creating filter with data:', newFilter);
            console.log('[BRANDS] Endpoint:', process.env.VUE_APP_API_ENDPOINT + 'create_inventory_filter');

            axios
              .post(
                process.env.VUE_APP_API_ENDPOINT + 'create_inventory_filter',
                newFilter,
                this.auth
              )
              .then((createResponse) => {
                console.log('[BRANDS] Create filter response:', createResponse);
                console.log('[BRANDS] Create response data:', createResponse.data);
                console.log('[BRANDS] Create response status:', createResponse.status);
                
                if (createResponse.data && createResponse.data.success !== false) {
                  console.log('[BRANDS] Filter created successfully');
                  console.log('[BRANDS] Response details:', createResponse.data.details);
                  
                  // Now add the first brand to the filter
                  // Try both filter_id and _id
                  const filterId = createResponse.data.details && (
                    createResponse.data.details.filter_id || 
                    createResponse.data.details._id
                  );
                  console.log('[BRANDS] Extracted filter_id:', filterId);
                  
                  if (filterId) {
                    const updateData = {
                          filter_id: filterId,
                          filter_name: this.newBrand.value_en,
                          filter_name_ar: this.newBrand.value_ar || '',
                          optype: 'Add',
                          created_by: localStorage.getItem('_id') || '',
                    };
                    console.log('[BRANDS] Adding brand to new filter with data:', updateData);
                    console.log('[BRANDS] Endpoint:', process.env.VUE_APP_API_ENDPOINT + 'update_inventory_filter');
                    
                    axios
                      .post(
                        process.env.VUE_APP_API_ENDPOINT + 'update_inventory_filter',
                        updateData,
                        this.auth
                      )
                      .then((updateResponse) => {
                        console.log('[BRANDS] Brand added to new filter response:', updateResponse);
                        console.log('[BRANDS] Brand added response data:', updateResponse.data);
                        
                        if (updateResponse.data && updateResponse.data.success !== false) {
                          console.log('[BRANDS] Brand added successfully to new filter!');
                          // Save the brand name before clearing
                          const newBrandName = this.newBrand.value_en;
                          
                          // Update brands array directly from response
                          if (updateResponse.data.details && updateResponse.data.details.filter_values && Array.isArray(updateResponse.data.details.filter_values)) {
                            const sortedBrands = updateResponse.data.details.filter_values.sort((a, b) => {
                              const nameA = (a.value_en || '').toLowerCase();
                              const nameB = (b.value_en || '').toLowerCase();
                              return nameA.localeCompare(nameB);
                            });
                            // Use splice to ensure Vue reactivity
                            this.brands.splice(0, this.brands.length, ...sortedBrands);
                            console.log('[BRANDS] Updated brands array from response:', this.brands);
                            console.log('[BRANDS] Brands count:', this.brands.length);
                            console.log('[BRANDS] Brands array contents:', JSON.stringify(this.brands));
                            // Force Vue to update the UI
                            this.$forceUpdate();
                          }
                          
                        alert('Brand added successfully!');
                        this.showBrandModal = false;
                          this.newBrand.value_en = '';
                          this.newBrand.value_ar = '';
                          
                          // Select the newly created brand
                          this.$nextTick(() => {
                            this.model.item_brand = newBrandName;
                            console.log('[BRANDS] Set model.item_brand to:', newBrandName);
                            console.log('[BRANDS] Current brands in dropdown:', this.brands);
                      });
                  } else {
                          console.error('[BRANDS] Failed to add brand to new filter. Response:', updateResponse.data);
                    alert('Brand filter created but failed to add brand. Please try again.');
                  }
                      })
                      .catch((error) => {
                        console.error('[BRANDS] Error adding brand to new filter:', error);
                        console.error('[BRANDS] Error response:', error.response);
                        alert('Error adding brand: ' + (error.response && error.response.data && error.response.data.message || error.message));
                      });
                } else {
                    console.error('[BRANDS] No filter_id found in create response');
                    console.error('[BRANDS] Full details object:', createResponse.data.details);
                    alert('Brand filter created but failed to add brand. Please try again.');
                  }
                } else {
                  console.error('[BRANDS] Failed to create brand filter. Response:', createResponse.data);
                  alert('Failed to create brand filter: ' + (createResponse.data && createResponse.data.message || 'Unknown error'));
                }
              })
              .catch((error) => {
                console.error('[BRANDS] Error creating brand filter:', error);
                console.error('[BRANDS] Error response:', error.response);
                alert('Error creating brand: ' + (error.response && error.response.data && error.response.data.message || error.message));
              });
          }
        })
        .catch((error) => {
          console.error('[BRANDS] Error loading brand filter:', error);
          console.error('[BRANDS] Error response:', error.response);
          alert('Error loading brands: ' + (error.response && error.response.data && error.response.data.message || error.message));
        });
    },

    loadBrands() {
      console.log('[BRANDS] loadBrands called');
      this.loadingBrands = true;
      this.brandsError = null;
      return axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_filter_all', {
          filters: { filter_name: 'brand' },
        })
        .then((response) => {
          console.log('[BRANDS] loadBrands response:', response);
          console.log('[BRANDS] response.data:', response.data);
          if (response.data && response.data.details && response.data.details.length > 0) {
            const brandFilter = response.data.details[0];
            console.log('[BRANDS] brandFilter:', brandFilter);
            console.log('[BRANDS] filter_values:', brandFilter.filter_values);
            if (brandFilter.filter_values && Array.isArray(brandFilter.filter_values)) {
              // Sort brands alphabetically by English name
              this.brands = brandFilter.filter_values.sort((a, b) => {
                const nameA = (a.value_en || '').toLowerCase();
                const nameB = (b.value_en || '').toLowerCase();
                return nameA.localeCompare(nameB);
              });
              console.log('[BRANDS] Loaded brands array:', this.brands);
              console.log('[BRANDS] Brands count:', this.brands.length);
            } else {
              console.warn('[BRANDS] No filter_values array found');
              this.brands = [];
            }
          } else {
            console.warn('[BRANDS] No brand filter found in response');
            this.brands = [];
          }
          return this.brands;
        })
        .catch((error) => {
          console.error('[BRANDS] Error loading brands:', error);
          this.brandsError = 'Failed to load brands. Please try again.';
          this.brands = [];
          throw error;
        })
        .finally(() => {
          this.loadingBrands = false;
          console.log('[BRANDS] loadBrands completed. Final brands count:', this.brands.length);
        });
    },

    addTag(newTag) {
      console.log('[TAGS] addTag called with:', newTag);
      if (!newTag) {
        console.log('[TAGS] No tag provided');
        return;
      }
      
      const tagText = typeof newTag === 'string' ? newTag.trim() : (newTag.tag || String(newTag));
      console.log('[TAGS] Processing tag text:', tagText);
      
      if (!tagText) {
        console.log('[TAGS] Empty tag text after processing');
        return;
      }
      
      // Check if tag already exists in tagData
      const existingTag = this.tagData.find(
        t => t && t.tag && t.tag.toLowerCase() === tagText.toLowerCase()
      );
      
      console.log('[TAGS] Existing tag found:', existingTag);
      console.log('[TAGS] Current model.item_tags before:', this.model.item_tags);
      
      if (existingTag) {
        // Tag exists, add it to the model if not already there
        if (!this.model.item_tags) {
          this.model.item_tags = [];
        }
        if (!this.model.item_tags.find(t => t && t.tag && t.tag === existingTag.tag)) {
          this.model.item_tags.push(existingTag);
          console.log('[TAGS] Added existing tag to model.item_tags');
        } else {
          console.log('[TAGS] Tag already in model.item_tags');
        }
      } else {
        // New tag - create a temporary tag object
        // It will be created on the backend when product is saved
        const tempTag = {
          tag: tagText,
          _id: 'temp_' + Date.now(),
          temp: true
        };
        
        if (!this.model.item_tags) {
          this.model.item_tags = [];
        }
        this.model.item_tags.push(tempTag);
        console.log('[TAGS] Created and added new temp tag:', tempTag);
        
        // Also add to tagData for future selections
        if (!this.tagData) {
          this.tagData = [];
        }
        this.tagData.push(tempTag);
        console.log('[TAGS] Added temp tag to tagData');
      }
      
      console.log('[TAGS] Final model.item_tags:', this.model.item_tags);
      console.log('[TAGS] Final model.item_tags length:', this.model.item_tags ? this.model.item_tags.length : 0);
    },
    addTagFromInput(event) {
      const input = event.target;
      const tagText = input.value.trim();
      if (tagText) {
        this.addTag(tagText);
        input.value = '';
                }
    },
    removeTag(index) {
      if (this.model.item_tags && this.model.item_tags.length > index) {
        this.model.item_tags.splice(index, 1);
        console.log('[TAGS] Removed tag at index', index);
          }
    },
    editTag(newTag) {
      // When editing, we have inventory_id, so we can create the tag via API
      if (!this.modals._id || !this.modals.user_id) {
        // If no inventory ID yet, just add locally like addTag
        const existingTag = this.tagData.find(
          t => t.tag && t.tag.toLowerCase() === newTag.toLowerCase()
        );
        
        if (existingTag) {
          if (!this.modals.item_tags.find(t => t.tag === existingTag.tag)) {
            this.modals.item_tags.push(existingTag);
          }
        } else {
          const tempTag = {
            tag: newTag,
            _id: 'temp_' + Date.now(),
            temp: true
          };
          this.modals.item_tags.push(tempTag);
          this.tagData.push(tempTag);
        }
        return;
      }
      
      // If we have inventory_id, create tag via API
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'create_tag', {
          tag: newTag,
          created_by: this.modals.user_id,
          inventory_id: this.modals._id,
        }, this.auth)
        .then((response) => {
          console.log('Tag created:', response);
          let ref = this;
          if (response.data && response.data.details) {
            // Refresh tag list
            axios
              .post(
                process.env.VUE_APP_API_ENDPOINT + 'read_tag_all',
                {},
                ref.auth
              )
              .then((response) => {
                if (response.data && response.data.details) {
                  ref.tagData = response.data.details;
                }
              })
              .catch((error) => {
                console.error('Error refreshing tags:', error);
              });
            
            // Add to modals if not already there
            if (!ref.modals.item_tags.find(t => t._id === response.data.details._id)) {
            ref.modals.item_tags.push(response.data.details);
          }
          }
        })
        .catch((error) => {
          console.error('Error creating tag:', error);
          const errorMsg = error.response?.data?.error || error.message || 'Failed to create tag';
          alert('Error creating tag: ' + errorMsg);
        });
    },
    // Tag modal methods
    showTagInputModal() {
      this.tagConfirmationModal.show = false;
      this.tagInputModal.show = true;
      this.tagInputModal.createdInventoryId = this.tagInputModal.createdInventoryId;
      this.tagInputModal.createdBy = this.tagInputModal.createdBy;
    },
    showEditTagConfirmationModal() {
      // Set up for edit mode
      console.log('Edit mode - modals._id (inventory ID):', this.modals._id);
      console.log('Edit mode - modals.item_id:', this.modals.item_id);
      console.log('Edit mode - modals.user_id:', this.modals.user_id);

      // Check if we have the required data
      if (!this.modals._id || !this.modals.user_id) {
        console.error('Missing required data for tag creation:');
        console.error('Inventory ID (_id):', this.modals._id);
        console.error('User ID (user_id):', this.modals.user_id);
        alert(
          'Error: Missing required data for tag creation. Please try again.'
        );
        return;
      }

      // Use the actual inventory _id, not item_id
      this.tagInputModal.createdInventoryId = this.modals._id;
      this.tagInputModal.createdBy = this.modals.user_id;
      this.tagInputModal.selectedTags = []; // Clear previous selections

      // Store in localStorage for consistency
      localStorage.setItem('currentInventoryId', this.modals._id);

      console.log('Tag modal setup complete:');
      console.log('createdInventoryId:', this.tagInputModal.createdInventoryId);
      console.log('createdBy:', this.tagInputModal.createdBy);

      // Show confirmation modal
      this.tagConfirmationModal.show = true;
    },
    skipTagCreation() {
      this.tagConfirmationModal.show = false;
      this.tagInputModal.show = false;
      this.resetTagModals();
    },
    resetTagModals() {
      this.tagConfirmationModal.show = false;
      this.tagInputModal.show = false;
      this.tagInputModal.selectedTags = [];
      this.tagInputModal.newTagInput = '';
      this.tagInputModal.createdInventoryId = '';
      this.tagInputModal.createdBy = '';
    },
    createTagFromInput() {
      console.log('[TAGS] createTagFromInput called');
      console.log('[TAGS] Input value:', this.tagInputModal.newTagInput);

      const tagText = this.tagInputModal.newTagInput.trim();
      if (tagText) {
        console.log('[TAGS] Creating tag:', tagText);
        this.createSingleTag(tagText);
        this.tagInputModal.newTagInput = '';
      } else {
        console.log('[TAGS] No input value to create tag');
        alert('Please enter a tag name.');
      }
    },
    selectTagFromMultiselect(newTag) {
      // Put the tag text in the input field for user to press Enter
      this.tagInputModal.newTagInput = newTag;
    },
    selectExistingTag(tag) {
      // Put the tag text in the input field for user to press Enter
      this.tagInputModal.newTagInput = tag.tag;
    },
    createSingleTag(tagText) {
      const querystring = require('querystring');
      const inventoryId =
        localStorage.getItem('currentInventoryId') ||
        this.tagInputModal.createdInventoryId ||
        this.modals._id;

      const createdBy =
        this.tagInputModal.createdBy ||
        this.modals.user_id ||
        localStorage.getItem('_id');

      console.log('[TAGS] Creating tag:', tagText);
      console.log('[TAGS] Inventory ID:', inventoryId);
      console.log('[TAGS] Created by:', createdBy);
      console.log('[TAGS] modals._id:', this.modals._id);
      console.log('[TAGS] modals.user_id:', this.modals.user_id);

      // If no inventory ID, this might be a new product - just add locally
      if (!inventoryId) {
        console.warn('[TAGS] No inventory ID - adding tag locally for new product');
        // Add to selected tags display
        if (!this.tagInputModal.selectedTags) {
          this.tagInputModal.selectedTags = [];
        }
        // Check if tag already exists
        const existingTag = this.tagInputModal.selectedTags.find(
          t => t.tag && t.tag.toLowerCase() === tagText.toLowerCase()
        );
        if (!existingTag) {
          this.tagInputModal.selectedTags.push({
            tag: tagText,
            _id: 'temp_' + Date.now(),
            temp: true
          });
          // Also add to tagData if not already there
          const existingInTagData = this.tagData.find(
            t => t.tag && t.tag.toLowerCase() === tagText.toLowerCase()
          );
          if (!existingInTagData) {
            this.tagData.push({
              tag: tagText,
              _id: 'temp_' + Date.now(),
              temp: true
            });
          }
          alert('Tag "' + tagText + '" added locally. It will be saved when you save the product.');
        } else {
          alert('Tag "' + tagText + '" is already selected.');
        }
        return;
      }

      if (!createdBy) {
        console.error('[TAGS] Missing created by');
        alert('Error: Missing user information. Please refresh the page and try again.');
        return;
      }

      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'create_tag',
          querystring.stringify({
            tag: tagText,
            created_by: createdBy,
            inventory_id: inventoryId,
          }),
          this.auth1
        )
        .then((response) => {
          console.log('[TAGS] Tag created successfully:', response);
          // Add to selected tags display
          if (!this.tagInputModal.selectedTags) {
            this.tagInputModal.selectedTags = [];
          }
          // Check if tag already exists in selected tags
          const existingTag = this.tagInputModal.selectedTags.find(
            t => t.tag && t.tag.toLowerCase() === tagText.toLowerCase()
          );
          if (!existingTag) {
          this.tagInputModal.selectedTags.push({
            tag: tagText,
            _id: response.data.details ? response.data.details._id : Date.now(),
          });
            alert('Tag "' + tagText + '" created successfully!');
          } else {
            alert('Tag "' + tagText + '" is already selected.');
          }

          // Refresh tag data to include the new tag
          this.refreshTagData();
        })
        .catch((error) => {
          console.error('[TAGS] Error creating tag:', error);
          console.error('[TAGS] Error response:', error.response);
          const errorMessage = error.response && error.response.data && error.response.data.message 
            ? error.response.data.message 
            : error.message || 'Unknown error';
          alert('Could not create tag: ' + errorMessage);
        });
    },
    refreshTagData() {
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_tag_all', {}, this.auth)
        .then((response) => {
          if (response.data.details) {
            this.tagData = response.data.details;
          }
        })
        .catch((error) => {
          console.error('Error refreshing tag data:', error);
        });
    },
    removeTagFromInputModal(index) {
      this.tagInputModal.selectedTags.splice(index, 1);
    },
    createcollectionwindow: function() {
      console.log('Opening project creation window');
      
      // Ensure created_by is set from the selected business user
      if (!this.collection.created_by && this.model.user_id) {
        this.collection.created_by = this.model.user_id;
      }
      
      // Validate that a business user is selected
      if (!this.collection.created_by) {
        alert('Please select a business user first before creating a project');
        return;
      }
      
      // Reset form fields
      this.collection.project_name = '';
      this.collection.project_description = '';
      this.collection.status = 'approved';
      
      this.createcollection = true;
    },
    deleteimage(index) {
      this.model.item_img.splice(index, 1);
      // Adjust cover image index if needed
      if (this.coverImageIndex === index) {
        // If deleted image was cover, set first image as cover
        this.coverImageIndex = 0;
      } else if (this.coverImageIndex > index) {
        // If deleted image was before cover, decrease cover index
        this.coverImageIndex--;
      }
      // Ensure cover index is valid
      if (this.coverImageIndex >= this.model.item_img.length) {
        this.coverImageIndex = Math.max(0, this.model.item_img.length - 1);
      }
      this.uploadPercentage = 0;
    },
    editdeleteimage(index) {
      this.modals.item_img.splice(index, 1);
      // Adjust cover image index if needed
      if (this.editCoverImageIndex === index) {
        // If deleted image was cover, set first image as cover
        this.editCoverImageIndex = 0;
      } else if (this.editCoverImageIndex > index) {
        // If deleted image was before cover, decrease cover index
        this.editCoverImageIndex--;
      }
      // Ensure cover index is valid
      if (this.editCoverImageIndex >= this.modals.item_img.length) {
        this.editCoverImageIndex = Math.max(0, this.modals.item_img.length - 1);
      }
      this.uploadPercentage = 0;
    },
    async addhadleimage(event, type, uploatype) {
      // Reference to the DOM input element
      console.log(event);
      console.log(type);
      console.log(this.$refs.file1.files);

      this.uploadPercentage = 0;
      if (uploatype == 'file') {
        for (var i = 0; i < this.$refs.file1.files.length; i++) {
          let file = this.$refs.file1.files[i];
          console.log(file);
          await this.upload(file, type);
        }
      }
    },
    async edithadleimage(event, type, uploatype) {
      // Reference to the DOM input element
      console.log(event);
      console.log(type);
      console.log(this.$refs.file2.files);
      this.uploadPercentage = 0;
      if (uploatype == 'file') {
        for (var i = 0; i < this.$refs.file2.files.length; i++) {
          let file = this.$refs.file2.files[i];
          console.log(file);
          await this.upload(file, 'edit');
        }
      }
    },
    async upload(file, type) {
      console.log(file);
      console.log(file);
      
      // Compress image if it's larger than 2MB
      const compressedFile = await compressImageIfNeeded(file);
      
      let fd = new FormData();
      fd.append('image', compressedFile, compressedFile.name);
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'image-upload', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 300000, // 2 minutes timeout for large files
          onUploadProgress: function(progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
            console.log(this.uploadPercentage);
          }.bind(this),
        })
        .then((response) => {
          console.log('Upload response:', response);
          if (response && response.data && response.data.imageUrl) {
          if (type == 'add') {
            this.imagearr.push(response.data.imageUrl);
            this.model.item_img = this.imagearr;
            // If this is the first image, set it as cover automatically
            if (this.model.item_img.length === 1) {
              this.coverImageIndex = 0;
            }
            console.log(this.model.item_img);
            document.getElementById('addimage').value = null;
          } else {
            this.editimagearr = this.modals.item_img;
            this.editimagearr.push(response.data.imageUrl);
            this.modals.item_img = this.editimagearr;
            // If this is the first image, set it as cover
            if (this.modals.item_img.length === 1) {
              this.editCoverImageIndex = 0;
            }
            console.log(this.modals.item_img);
            document.getElementById('editimage').value = null;
            }
            // Reset upload percentage after success
            this.uploadPercentage = 0;
          } else {
            console.error('Invalid response format:', response);
            alert('Upload failed: Invalid response from server');
            this.uploadPercentage = 0;
          }
        })
        .catch((error) => {
          console.error('Upload error:', error);
          this.uploadPercentage = 0;
          
          if (error.code === 'ECONNABORTED') {
            alert('Upload timeout. The file may be too large. Please try a smaller file or check your connection.');
          } else if (error.response) {
            // Server responded with error
            const status = error.response.status;
            // Handle different error response formats
            let message = 'Unknown error';
            if (error.response.data?.errors && error.response.data.errors.length > 0) {
              message = error.response.data.errors[0].detail || error.response.data.errors[0].title || 'Unknown error';
            } else if (error.response.data?.message) {
              message = error.response.data.message;
            } else if (error.response.data?.error) {
              message = error.response.data.error;
            }
            
            if (status === 413) {
              alert('File too large! Please compress the image or use a smaller file (max 50MB).');
            } else if (status === 422) {
              alert('Upload failed: ' + message);
            } else {
              alert('Upload failed: ' + message + ' (Status: ' + status + ')');
            }
          } else if (error.request) {
            // Request made but no response
            alert('Upload failed: No response from server. Please check your connection and try again.');
          } else {
            alert('Upload failed: ' + (error.message || 'Unknown error'));
          }
        });
    },
    getprojectdata() {
      if (!this.model.user_id) {
        this.collectionData = [];
        return;
      }
      
      this.collection.created_by = this.model.user_id;
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'read_project_by_user',
          { created_by: this.model.user_id, status: 'approved' },
          this.auth
        )
        .then((response) => {
          console.log('Projects loaded:', response);
          if (response.data && response.data.details) {
            this.collectionData = response.data.details;
          } else {
            this.collectionData = [];
          }
        })
        .catch((error) => {
          console.error('Error loading projects:', error);
          this.collectionData = [];
        });
    },
    editgetprojectdata() {
      this.collection.created_by = this.modals.user_id;
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'read_project_by_user',
          { created_by: this.modals.user_id, status: 'approved' },
          this.auth
        )
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.collectionData = response.data.details;
          } else {
            this.collectionData = [];
          }
        });
    },
    saveprojects() {
      console.log('Creating project:', this.collection);
      
      // Validate required fields
      if (!this.collection.project_name || !this.collection.project_name.trim()) {
        alert('Please enter project name');
        return;
      }
      
      if (!this.collection.created_by) {
        alert('Please select a business user first');
        return;
      }

      const querystring = require('querystring');
      const projectData = {
        project_name: this.collection.project_name.trim(),
        project_description: this.collection.project_description || '',
        created_by: this.collection.created_by,
        status: this.collection.status || 'approved',
      };

      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'create_project',
          querystring.stringify(projectData),
          this.auth1
        )
        .then((response) => {
          console.log('Project creation response:', response);
          
          if (response.data && response.data.success !== false) {
            // Reload projects for the user
            axios
              .post(
                process.env.VUE_APP_API_ENDPOINT + 'read_project_by_user',
                {
                  created_by: this.collection.created_by,
                  status: 'approved',
                },
                this.auth
              )
              .then((projectResponse) => {
                console.log('Projects reloaded:', projectResponse);
                if (projectResponse.data && projectResponse.data.details) {
                  this.collectionData = projectResponse.data.details;
                  // Auto-select the newly created project
                  if (response.data.details) {
                    const newProject = response.data.details;
                    if (newProject.project_id) {
                      this.model.project_id = newProject.project_id;
                    } else if (newProject._id) {
                      // Find the project in the reloaded list
                      const foundProject = this.collectionData.find(
                        p => p._id && p._id.toString() === newProject._id.toString()
                      );
                      if (foundProject && foundProject.project_id) {
                        this.model.project_id = foundProject.project_id;
                      }
                    }
                  }
                } else {
                  this.collectionData = [];
                }
              })
              .catch((error) => {
                console.error('Error reloading projects:', error);
              });

            // Reset form
            this.collection.project_name = '';
            this.collection.project_description = '';
            
            // Update button state
            let ref = this;
            const btn = document.getElementById('savecollectionbtn');
            if (btn) {
              btn.classList.remove('btn-primary');
              btn.classList.add('btn-success');
              btn.innerHTML = 'Saved!';
              setTimeout(function() {
                btn.classList.remove('btn-success');
                btn.classList.add('btn-primary');
                btn.innerHTML = 'Save';
                ref.createcollection = false;
              }, 2000);
            } else {
              // Fallback if button not found
              alert('Project created successfully!');
              this.createcollection = false;
            }
          } else {
            const errorMsg = response.data && response.data.message || 'Unknown error';
            alert('Failed to create project: ' + errorMsg);
            console.error('Project creation failed:', response.data);
          }
        })
        .catch((error) => {
          console.error('Error creating project:', error);
          const errorMsg = error.response && error.response.data && error.response.data.message || error.message || 'Unknown error';
          alert('Error creating project: ' + errorMsg);
        });
    },
    saveitem() {
      if (this.$v.model.$error === false) {
        const querystring = require('querystring');
        let item_mentions = '';
        let item_imgs = '';
        let item_tags = '';
        if (this.model.item_mentions.length > 0) {
          for (var i = 0; i < this.model.item_mentions.length; i++) {
            item_mentions += this.model.item_mentions[i]._id + ',';
          }
          var item_mention = item_mentions.substring(
            0,
            item_mentions.length - 1
          );
        }
        if (this.model.item_img.length > 0) {
          // Reorder images to put cover image first
          const reorderedImages = [...this.model.item_img];
          if (this.coverImageIndex > 0 && this.coverImageIndex < reorderedImages.length) {
            const coverImage = reorderedImages[this.coverImageIndex];
            reorderedImages.splice(this.coverImageIndex, 1);
            reorderedImages.unshift(coverImage);
          }
          
          for (var i = 0; i < reorderedImages.length; i++) {
            item_imgs += reorderedImages[i] + ',';
          }
          var item_img = item_imgs.substring(0, item_imgs.length - 1);
        }
        if (this.model.item_tags.length > 0) {
          for (var i = 0; i < this.model.item_tags.length; i++) {
            item_tags += this.model.item_tags[i].tag + ',';
          }
          var item_tag = item_tags.substring(0, item_tags.length - 1);
        }
        console.log(item_tag);
        console.log(item_img);
        console.log(item_mention);

        let details = {
          item_name: this.model.item_name,
          item_description: this.model.item_description,
          item_name_ar: this.model.item_name_ar,
          item_description_ar: this.model.item_description_ar,
          item_type: this.model.item_type,
          item_visibility: this.model.item_visibility,
          item_category: this.model.item_category,
          item_subcategory: this.model.item_subcategory,
          item_space: this.model.item_space,
          item_brand: this.model.item_brand,
          item_cost: this.model.item_cost,
          optype: this.model.optype,
          created_by: this.model.user_id,
          status: this.model.status,
        };
        if (item_mention) {
          details.item_mentions = item_mention;
        }
        if (item_img) {
          details.item_img = item_img;
        }
        if (item_tag) {
          details.item_tags = item_tag;
        }

        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT + 'create_inventory',
            querystring.stringify(details),
            this.auth1
          )
          .then((response) => {
            //item_tags:this.model.item_tags,
            console.log(response);
            if (response.data && response.data.details) {
              let inventoryId;
              if (response.data.details.inventory) {
                inventoryId = response.data.details.inventory._id;
              } else if (response.data.details._id) {
                inventoryId = response.data.details._id;
              }
              
              if (inventoryId && this.model.project_id) {
                console.log('Calling update_project with:', {
                  project_id: this.model.project_id,
                  created_by: this.model.user_id,
                  items: inventoryId
                });
                
                axios
                  .post(
                    process.env.VUE_APP_API_ENDPOINT + 'update_project',
                    querystring.stringify({
                      project_id: this.model.project_id,
                      user_oid: this.model.user_id,
                      created_by: this.model.user_id,
                      optype: 'Add',
                      items: inventoryId,
                    }),
                    this.auth1
                  )
                  .then((updateResponse) => {
                    console.log('update_project response:', updateResponse);
                    console.log('update_project response.data:', updateResponse.data);
                    if (updateResponse.data && updateResponse.data.success) {
                      console.log('✅ Successfully added item to project!');
                    } else {
                      console.error('❌ Failed to update project:', updateResponse.data);
                      const errorMsg = (updateResponse.data && updateResponse.data.message) || 'Unknown error';
                      alert(`Item created but failed to add to project: ${errorMsg}. Please check the server logs.`);
                    }
                  })
                  .catch((error) => {
                    console.error('❌ Error updating project:', error);
                    console.error('Error response:', error.response && error.response.data);
                    alert(`Item created but failed to add to project. Error: ${error.message || 'Unknown error'}. Please check the server logs.`);
                  });
              } else {
                console.warn('Missing inventory ID or project ID:', {
                  inventoryId,
                  project_id: this.model.project_id
                });
              }
            }
            document
              .getElementById('saveuserbtn')
              .classList.remove('btn-primary');
            document.getElementById('saveuserbtn').classList.add('btn-success');
            document.getElementById('saveuserbtn').innerHTML = 'Saved!';

            // Store the created inventory details for tag creation
            if (response.data.details && response.data.details.inventory) {
              this.tagInputModal.createdInventoryId = response.data.details.inventory._id;
              this.tagInputModal.createdBy = this.model.user_id;

              // Store in localStorage like React version
              localStorage.setItem(
                'currentInventoryId',
                response.data.details.inventory._id
              );
            }

            // Show tag confirmation modal after a short delay
            setTimeout(() => {
              this.tagConfirmationModal.show = true;
            }, 1000);
          });
      }
    },
    updateitem() {
      if (this.$v.modals.$error === false) {
        const querystring = require('querystring');
        let item_mentions = '';
        let item_imgs = '';
        let item_tags = '';
        if (this.modals.item_mentions.length > 0) {
          for (var i = 0; i < this.modals.item_mentions.length; i++) {
            item_mentions += this.modals.item_mentions[i]._id + ',';
          }
          var item_mention = item_mentions.substring(
            0,
            item_mentions.length - 1
          );
        }
        if (this.modals.item_img.length > 0) {
          // Reorder images to put cover image first
          const reorderedImages = [...this.modals.item_img];
          if (this.editCoverImageIndex > 0 && this.editCoverImageIndex < reorderedImages.length) {
            const coverImage = reorderedImages[this.editCoverImageIndex];
            reorderedImages.splice(this.editCoverImageIndex, 1);
            reorderedImages.unshift(coverImage);
          }
          
          for (var i = 0; i < reorderedImages.length; i++) {
            item_imgs += reorderedImages[i] + ',';
          }
          var item_img = item_imgs.substring(0, item_imgs.length - 1);
        }
        if (this.modals.item_tags.length > 0) {
          for (var i = 0; i < this.modals.item_tags.length; i++) {
            item_tags += this.modals.item_tags[i].tag + ',';
          }
          var item_tag = item_tags.substring(0, item_tags.length - 1);
        }
        console.log(item_tag);
        console.log(item_img);
        console.log(item_mention);

        let details = {
          item_id: this.modals.item_id,
          item_name: this.modals.item_name,
          item_description: this.modals.item_description,
          item_name_ar: this.modals.item_name_ar,
          item_description_ar: this.modals.item_description_ar,
          item_type: this.modals.item_type,
          item_visibility: this.modals.item_visibility,
          item_category: this.modals.item_category,
          item_subcategory: this.modals.item_subcategory,
          item_space: this.modals.item_space,
          item_brand: this.modals.item_brand,
          item_cost: this.modals.item_cost,
          optype: this.modals.optype,
          created_by: this.modals.user_id,
          status: this.modals.status,
        };
        if (item_mention) {
          details.item_mentions = item_mention;
        }
        if (item_img) {
          details.item_img = item_img;
        }
        if (item_tag) {
          details.item_tags = item_tag;
        }

        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT + 'update_inventory',
            querystring.stringify(details),
            this.auth1
          )
          .then((response) => {
            //item_tags:this.modals.item_tags,
            console.log(response);
            if (response.data.details) {
              axios
                .post(
                  process.env.VUE_APP_API_ENDPOINT + 'update_project',
                  querystring.stringify({
                    project_id: this.modals.project_id,
                    user_oid: this.modals.user_id,
                    created_by: this.modals.user_id,
                    optype: 'Add',
                    items: response.data.details._id,
                  }),
                  this.auth1
                )
                .then((response) => {
                  console.log(response);
                });
            }
            document
              .getElementById('updateuserbtn')
              .classList.remove('btn-primary');
            document
              .getElementById('updateuserbtn')
              .classList.add('btn-success');
            document.getElementById('updateuserbtn').innerHTML = 'Loading...';
            setTimeout(function() {
              document
                .getElementById('updateuserbtn')
                .classList.remove('btn-success');
              document
                .getElementById('updateuserbtn')
                .classList.add('btn-primary');
              document.getElementById('updateuserbtn').innerHTML = 'Saved';
              window.location.reload();
            }, 2000);
          });
      }
    },
    getsubcategoriesadd(event) {
      // Use the improved loadSubcategories method
      this.loadSubcategories(this.model.item_category, false);
    },
    editgetsubcategoriesadd(event) {
      // Use the improved loadSubcategories method
      this.loadSubcategories(this.modals.item_category, true);
    },
    deleteproduct(row) {
      console.log(row);
      const querystring = require('querystring');
      swal({
        title: 'Delete this item?',
        text: 'This action is not reversible.',
        icon: 'warning',
        buttons: { cancel: true, confirm: true },
      }).then((result) => {
        // <--
        if (result) {
          console.log('result cloud', result);
          axios
            .post(
              process.env.VUE_APP_API_ENDPOINT + 'delete_inventory',
              querystring.stringify({
                item_id: row.item_id,
                created_by: row.created_by._id,
              }),
              this.auth1
            )
            .then((response) => {
              console.log(response);
              swal({
                title: 'Deleted!',
                text: 'Your file has been deleted.',
                icon: 'success',
              }).then((result) => {
                console.log(result);
                window.location.reload();
              });
            });
        }
      });
    },
    // Set cover image for add mode
    setCoverImage(index) {
      if (index >= 0 && index < this.model.item_img.length) {
        this.coverImageIndex = index;
      }
    },
    
    // Set cover image for edit mode
    setEditCoverImage(index) {
      if (index >= 0 && index < this.modals.item_img.length) {
        this.editCoverImageIndex = index;
      }
    },
    
    openproduct: function(tcdata) {
      const querystring = require('querystring');
      console.log(tcdata);
      let tags = [];
      this.modals.project_id = '';
      // Reset cover image index for edit mode
      this.editCoverImageIndex = 0;
      if (tcdata.created_by) {
        axios
          .post(
            process.env.VUE_APP_API_ENDPOINT + 'read_project_by_user',
            {
              created_by: tcdata.created_by._id,
              status: 'approved',
            },
            this.auth
          )
          .then((response) => {
            console.log(response);
            if (response.data.details) {
              this.collectionData = response.data.details;
              for (var i = 0; i < this.collectionData.length; i++) {
                for (
                  var j = 0;
                  j < this.collectionData[i].project_items.length;
                  j++
                ) {
                  if (
                    this.collectionData[i].project_items[j]._id == tcdata._id
                  ) {
                    this.modals.project_id = this.collectionData[i].project_id;
                    this.modals.project_id1 = this.collectionData[i].project_id;
                  }
                }
              }
            }
          });

        this.modals.created_by = tcdata.created_by._id;
        this.modals.user_id = tcdata.created_by._id;
        this.collection.created_by = tcdata.created_by._id;
      }

      this.modals.item_name = tcdata.item_name;
      this.modals._id = tcdata._id;
      this.modals.item_name_ar = tcdata.item_name_ar;
      this.modals.item_description_ar = tcdata.item_description_ar;
      this.modals.item_description = tcdata.item_description;
      this.modals.item_visibility = tcdata.item_visibility;

      if (tcdata.item_subcategory) {
        this.modals.item_subcategory = tcdata.item_subcategory._id;
      }
      if (tcdata.item_category) {
        this.modals.item_category = tcdata.item_category._id;
        // Use the improved loadSubcategories method
        this.loadSubcategories(this.modals.item_category, true);
      }

      this.modals.item_space = tcdata.item_space;
      this.modals.item_brand = tcdata.item_brand;
      this.modals.item_cost = tcdata.item_cost;
      this.modals.item_theme_color = tcdata.item_theme_color;
      for (var i = 0; i < tcdata.item_tags.length; i++) {
        tags.push({ tag: tcdata.item_tags[i] });
      }

      this.modals.item_tags = tags;
      this.modals.item_img = tcdata.item_img;
      this.modals.item_mentions = tcdata.item_mentions;
      this.modals.status = tcdata.status;
      // if(tcdata.sub_category[0]){
      //  this.modals.sub_category={'sub_id':tcdata.sub_category[0].subcat_id,'name':tcdata.sub_category_name[0]};
      //  //this.modals.sub_category=tcdata.sub_category[0].subcat_id;
      //  this.model.sub_category_name=tcdata.sub_category_name[0];
      // }
      this.modals.item_id = tcdata.item_id;
      this.modals.editproduct = true;
      console.log(this.modals);
    },
    getsubcategories(event) {
      // Reset subcategory when category changes in filter
      this.modals.item_subcategory = '';
      this.filtercategoryproduct();
      // Load subcategories for the selected category
      this.loadSubcategories(this.modals.item_category, false);
    },
    updateproduct() {
      console.log(this.modals);
      let tags = [];
      // if(this.modals.item_tags){
      //  tags=this.modals.item_tags.split(',');
      // }
      if (this.modals.item_category) {
        let item_category = this.modals.item_category.split('#');
        this.modals.item_category = item_category[0];
      }
      const querystring = require('querystring');
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + 'update_inventory',
          querystring.stringify({
            item_id: this.modals.item_id,
            item_name: this.modals.item_name,
            item_name_ar: this.modals.item_name_ar,
            item_description: this.modals.item_description,
            item_tags: this.modals.item_tags,
            item_type: this.modals.item_type,
            item_visibility: this.modals.item_visibility,
            item_category: this.modals.item_category,
            item_subcategory: this.modals.item_subcategory,
            item_cost: this.modals.item_cost,
            created_by: this.modals.created_by,
            status: this.modals.status,
          }),
          this.auth1
        )
        .then((response) => {
          console.log(response);
          this.message = response.data.message;
          document.getElementById('updatebtn1').classList.remove('btn-primary');
          document.getElementById('updatebtn1').classList.add('btn-success');
          document.getElementById('updatebtn1').innerHTML = 'Updated';
          setTimeout(function() {
            document
              .getElementById('updatebtn1')
              .classList.remove('btn-success');
            document.getElementById('updatebtn1').classList.add('btn-primary');
            document.getElementById('updatebtn1').innerHTML = 'Update';
            window.location.reload();
          }, 2000);
        });
    },

    previouspage() {
      console.log(this.auth);
      if (this.offset >= 0) {
        --this.offset;
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_all', {
            details: { item_type: 'Product' },
            offset: this.offset,
          })
          .then((response) => {
            console.log(response);
            if (response.data.details) {
              this.productData = response.data.details;
            }
          });
      }
    },
    gotopage() {
      const querystring = require('querystring');
      console.log(this.auth);
      if (document.getElementById('page_no').value) {
        this.offset = document.getElementById('page_no').value;
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_all', {
            details: { item_type: 'Product' },
            offset: this.offset,
          })
          .then((response) => {
            console.log(response);
            if (response.data.details) {
              this.productData = response.data.details;
            }
          });
      }
    },
    nextpage() {
      this.offset = this.offset + 1;
      const querystring = require('querystring');
      console.log(this.auth);
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_all', {
          details: { item_type: 'Product' },
          offset: this.offset,
        })
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.productData = response.data.details;
          }
        });
    },
    searchproduct() {
      const querystring = require('querystring');
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_all', {
          details: { item_type: 'Product' },
          offset: '0',
          item_name: this.search,
        })
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.deleteitem = false;
            this.searchData = response.data.details;
          } else if (response.data.message == 'Data not found') {
            this.productData = [];
            this.deleteitem = true;
          }
        });
    },
    filterproduct() {
      const querystring = require('querystring');
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_all', {
          offset: '0',
          details: {
            item_type: 'Product',
            item_category: this.modals.item_category,
            item_subcategory: this.modals.item_subcategory,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.deleteitem = false;
            this.productData = response.data.details;
          } else if (response.data.message == 'Data not found') {
            this.productData = [];
            this.deleteitem = true;
          }
        });
    },
    filtercategoryproduct() {
      const querystring = require('querystring');
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_all', {
          offset: '0',
          details: {
            item_type: 'Product',
            item_category: this.modals.item_category,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.deleteitem = false;
            this.productData = response.data.details;
          } else if (response.data.message == 'Data not found') {
            this.productData = [];
            this.deleteitem = true;
          }
        });
    },
    filterbrandproduct() {
      console.log(this.modals.item_brand);
      const querystring = require('querystring');
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_all', {
          offset: '0',
          details: {
            item_type: 'Product',
            item_brand: this.modals.item_brand,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.deleteitem = false;
            this.productData = response.data.details;
          } else if (response.data.message == 'Data not found') {
            this.productData = [];
            this.deleteitem = true;
          }
        });
    },
    cleardata() {
      const querystring = require('querystring');
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + 'read_inventory_all', {
          offset: '0',
          details: { item_type: 'Product' },
        })
        .then((response) => {
          console.log(response);
          if (response.data.details) {
            this.productData = response.data.details;
            this.modals.item_category = '';
            this.modals.item_subcategory = '';
            this.modals.item_brand = '';
            this.subcategories = [];
            this.deleteitem = false;
          }
        });
    },
  },
};
</script>
<style>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 700px;
    margin: 1.75rem auto;
  }
}
.product-image {
  max-height: 200px;
  overflow: hidden;
}
.product-image img {
  min-height: 200px;
}
</style>
